const o = [
  {
    name: '运营看板',
    src: require('@/assets/icon_navleft_01.png'),
    value: '/admin/index',
  },
  {
    name: '车辆定位',
    src: require('@/assets/icon_navleft_13.png'),
    value: '/admin/carposition',
  },
  {
    name: '运单管理',
    src: require('@/assets/icon_navleft_02.png'),
    value: '/order',
    children: [
      {
        name: '运单列表',
        value: '/order/nocontract',
      },
      {
        name: '运单补差',
        value: '/order/makeup',
      },
      {
        name: '运单回收站',
        value: '/order/recycle',
      },
    ],
  },
  {
    name: '客户管理',
    src: require('@/assets/icon_navleft_04.png'),
    value: '/customer',
    children: [
      {
        name: '客户列表',
        value: '/customer/manage',
      },
      {
        name: '操作日志',
        value: '/customer/log',
      },
    ],
  },
  {
    name: '车辆管理',
    src: require('@/assets/icon_navleft_05.png'),
    value: '/vehicle',
    children: [
      {
        name: '车辆列表',
        value: '/vehicle/manage',
      },
      {
        name: '挂车管理',
        value: '/vehicle/hang',
      },
      {
        name: '违章管理',
        value: '/vehicle/breakRules',
      },
      {
        name: '车辆年检',
        value: '/vehicle/inspect',
      },
      {
        name: '临期查询',
        value: '/vehicle/documents',
      },
    ],
  },
  {
    name: '维保管理',
    src: require('@/assets/icon_navleft_06.png'),
    value: '/fix',
    children: [
      {
        name: '维保列表',
        value: '/fix/list',
      },
    ],
  },
  {
    name: '人员管理',
    src: require('@/assets/icon_navleft_07.png'),
    value: '/staff',
    children: [
      {
        name: '车队长管理',
        value: '/staff/captain/table',
      },
      {
        name: '会计管理',
        value: '/staff/mainAccountant/table',
      },
      {
        name: '机务管理',
        value: '/staff/maintenance/table',
      },
      {
        name: '车务管理',
        value: '/staff/vehicleService/table',
      },
      {
        name: '司机管理',
        value: '/staff/driver',
      },
      {
        name: '押运员管理',
        value: '/staff/escort',
      },
    ],
  },
  {
    name: '财务管理',
    src: require('@/assets/icon_navleft_08.png'),
    value: '/finance',
    children: [
      {
        name: '预警管理',
        value: '/finance/financeFleetAbnormal',
      },
      {
        name: '运费统计表',
        value: '/finance/feightStatistics',
      },
      {
        name: '预支款管理',
        value: '/finance/initialPayment',
      },
      {
        name: '应收账款管理',
        value: '/finance/shipper',
      },
      {
        name: '固定费用支出表',
        value: '/finance/fixedFeeList',
      },
      {
        name: '出车费用汇总表',
        value: '/finance/expenseSummary',
      },
      {
        name: '油气费汇总表',
        value: '/finance/oilFee',
      },
      {
        name: '车队利润表',
        value: '/finance/estimatedProfit',
      },
      {
        name: '月度统计表',
        value: '/finance/monthlyStatistical',
      },
    ],
  },
  {
    name: '系统设置',
    src: require('@/assets/icon_navleft_09.png'),
    value: '/system',
    children: [
      {
        name: '提醒人配置',
        value: '/system/reminderConfig',
      },
      {
        name: '预警阈值设置',
        value: '/system/warningConfig',
      },
      {
        name: '工资提成设置',
        value: '/finance/baseSalary',
      },
      {
        name: '固定费用配置',
        value: '/finance/fixedFee',
      },
      {
        name: '出车费用配置',
        value: '/finance/drivingFee',
      },
      {
        name: '附加费用配置',
        value: '/system/extraFeeConfig',
      },
      {
        name: '油气站配置',
        value: '/system/stationConfig',
      },
      {
        name: '货物配置',
        value: '/system/cargoConfig',
      },
      {
        name: '车辆类型配置',
        value: '/system/vehicleTypeConfig',
      },
      {
        name: '车辆证件配置',
        value: '/system/documentConfig',
      },
      {
        name: '车辆保险配置',
        value: '/system/insuranceConfig',
      },
      {
        name: '维保类型配置',
        value: '/fix/config',
      },
      {
        name: '基础设置',
        value: '/system/others',
      },
      {
        name: '登录日志',
        value: '/system/loginLog',
      },
    ],
  },
  {
    name: '帮助中心',
    src: require('@/assets/icon_navleft_15.png'),
    value: '/help',
    children: [
      // {
      //   name: '操作手册',
      //   value: '/help/operation',
      // },
      {
        name: '更新日志',
        value: '/help/log',
      },
      {
        name: '改进建议',
        value: '/help/improve',
      },
    ],
  },
]

export default o